"use client";
import React, { useEffect, useState } from "react";
import styles from "./dashboard.module.scss";

const Dashboard = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const formatDate = (datetimeString) => {
    // Parse the datetime string
    const date = new Date(datetimeString);

    // Get the day, month, and year
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();

    // Format the date as "7 Jan 2025"
    return `${day} ${month} ${year}`;
}

  const fetchDashboardFromIndexDB = () => {
    const sessionData  = sessionStorage.getItem("RefferalData");
    const isNewUser  = sessionStorage.getItem("RefferalDataNewUser");

    if(sessionData){
      setData(JSON.parse(sessionData))
      setIsLoading(false)
    }

    if(isNewUser !== "true")
    {
      window.location.href = "/referral/check-status";
    }
  };

  useEffect(() => {
    // fetchDashboard();

    fetchDashboardFromIndexDB();
  }, []);

  const totalPages = Math.ceil(data.length / itemsPerPage);
  const paginatedData = data.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <>
      <div className={styles.container}>
        {/* Heading */}
        <h2 className={styles.heading}>Status</h2>

        {/* Table */}
        <div className={styles.tableContainer}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Refer Date</th>
                <th>Referee Name</th>
                <th>Referee Email ID</th>
                <th>Referee Mobile</th>
                <th>Referral Status</th>
                <th>Referral Validity</th>
                <th>Amazon Voucher</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.length === 0 ? (
                <tr>
                  <td colSpan={8} className="text-center">
                   {!isLoading ?  "No data available" : "Loading data..."}
                  </td>
                </tr>
              ) : (
                paginatedData.map((row, index) => (
                  <tr key={index}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>{formatDate(row.CreatedOn)}</td>
                    <td>{row.FirstName}</td>
                    <td>{row.EmailAddress}</td>
                    <td>{row.Phone}</td>
                    <td>{row.LeadStatus}</td>
                    <td>{row.Validity}</td>
                    <td>{row.Voucher}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className={styles.paginationContainer}>
          <div
            className="paginationControls"
            style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}
          >
            <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
            &lt;
            </button>
            {Array.from({ length: totalPages }, (_, index) => {
              const pageNumber = index + 1;

              if (
                (currentPage === 1 && pageNumber <= 3) || 
                pageNumber === currentPage || 
                pageNumber === currentPage - 1 || 
                pageNumber === currentPage + 1 
              ) {
                return (
                  <button
                    key={pageNumber}
                    onClick={() => handlePageChange(pageNumber)}
                    className={currentPage === pageNumber ? styles.activePage : ""}
                  >
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })}
            
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
           &gt;
            </button>
          </div>
          {/* Refer More Button */}
          <button className={styles.referMoreButton}>
            <a href="/referral"> Refer More </a>
          </button>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
